// The code in this file will load on every page of your site
import {local} from "wix-storage";
import wixLocation from "wix-location";
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import {session} from 'wix-storage';

let previousPagePrefix;
$w.onReady(function () 
{
	
	//$w("#horizontalMenu4").hide();
	//$w("#header1").style.backgroundColor
	// $w("#searchHeader").value ='';
	// $w("#searchHeader").placeholder ='Search adviser database...';

	// $w("#searchHeader").onKeyPress((event) => {
	// 	if (event.key === "Enter")
	// 	{
	// 		runSearch();
	// 	}
	// })
	// previousPagePrefix = local.getItem("page");
	// local.setItem("previousPagePrefix", previousPagePrefix)
  	// //local.setItem("page", wixLocation.path);
	// console.log(previousPagePrefix);
});

function runSearch ()
{
	//let search = $w("#searchHeader").value; 
	// local.setItem("searchWord", search);
	// wixLocation.to(`/search-results`);
}

// export function searchHeaderImage_click(event) 
// {
// 	runSearch();
// }




export function text445_click(event) 
{
	$w("#wixChat1").maximize();
}